import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';
import { HHInput, HHTextArea, HHCheckbox } from './fields';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) =>
    Yup.object().shape({
      name: Yup.string()
        .required(translate('form.error.mixed.required')),
      email: Yup.string()
        .required(translate('form.error.mixed.required')),
      phone: Yup.string()
        .required(translate('form.error.mixed.required')),
      city: Yup.string()
        .required(translate('form.error.mixed.required')),
      school: Yup.string()
        .required(translate('form.error.mixed.required')),
      details: Yup.string()
        .required(translate('form.error.mixed.required')),
      agreeTerms: Yup.boolean().test(
        'mustBeTrue',
        translate('form.error.boolean.agreeIndication'),
        // eslint-disable-next-line func-names, prefer-arrow-callback
        function (value) {
          return value;
        }
      )
    }),
  mapPropsToValues: props => props.initialValues,
  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  }
});

const ScheduleDemoForm = props => {
  const {
    handleSubmit, isSubmitting, translate
  } = props;

  return (
    <Form onSubmit={handleSubmit} className='scheduleDemo'>
      <Form.Field >
        <label htmlFor='name'>{translate('form.label.name')} *</label>
        <Field
          name='name'
          component={HHInput}
          otherProps={{
              type: 'text',
              id: 'name'
            }}
        />
      </Form.Field>

      <Form.Field >
        <label htmlFor='email'>{translate('form.label.email')} *</label>
        <Field
          name='email'
          component={HHInput}
          otherProps={{
              id: 'email',
              type: 'text'
            }}
        />
      </Form.Field>

      <Form.Field >
        <label htmlFor='phone'>{translate('form.label.phoneNumber')} *</label>
        <Field
          name='phone'
          component={HHInput}
          otherProps={{
              id: 'phone',
              type: 'text'
            }}
        />
      </Form.Field>

      <Form.Field>
        <label htmlFor='city'>{translate('form.label.cityCountry')} *</label>
        <Field
          name='city'
          component={HHInput}
          otherProps={{
              type: 'text',
              id: 'city'
            }}
        />
      </Form.Field>

      <Form.Field>
        <label htmlFor='school'>{translate('form.label.school')} *</label>
        <Field
          name='school'
          component={HHInput}
          otherProps={{
              type: 'text',
              id: 'school'
            }}
        />
      </Form.Field>

      <Form.Field>
        <label htmlFor='details'>{translate('details')} *</label>
        <Field
          name='details'
          component={HHTextArea}
          otherProps={{
              type: 'text',
              id: 'details'
            }}
        />
      </Form.Field>

      <Form.Field>
        <label >{translate('form.label.agreeToContact')}</label>
      </Form.Field>

      <Form.Field className='agreeField'>
        <Field
          name='agreeTerms'
          component={HHCheckbox}
        />
        <span style={{ marginLeft: '7px', fontWeight: '700', color: '#666' }}>
          {translate('form.label.agreeToTermOfUse')}
        </span>

      </Form.Field>

      <Button
        primary
        disabled={isSubmitting}
        loading={isSubmitting}
        type='submit'
      >
        {translate('submit')}
      </Button>

    </Form>
  );
};

export default compose(
  withLocalize,
  formikEnhancer
)(ScheduleDemoForm);



// WEBPACK FOOTER //
// ./src/components/forms/scheduleDemoForm.js